import { useEffect, useState } from "react";
import { toast } from "sonner";
import { BookOpen, Copy, ExternalLink } from "lucide-react";
import { WhatsAppGlyph } from "@/components/cards/CardShell";
import { catalogUrl, fetchCatalogs } from "@/lib/bf";

export default function BFAgentCatalogs({ cfg, base, name, phone }) {
  const [list, setList] = useState([]);
  useEffect(() => { fetchCatalogs().then((l) => setList(l.filter((x) => !x.group))).catch(() => {}); }, []);
  if (!list.length) return null;
  const origin = (() => { try { return new URL(base).origin; } catch { return window.location.origin; } })();
  const link = (k) => `${origin}/api/bf/catalogs/${k.id}/file`;
  const brand = (id) => cfg.brands.find((b) => b.id === id)?.name || id;
  const text = (k) => `Bună ziua! Vă trimit ${k.title} (${brand(k.brand)}), ca să-l aveți la îndemână când alegeți produsele: ${link(k)}\nOferta Black Friday Beauty Trends: ${base}#b/${k.brand}${name ? `\n${name}` : ""}${phone ? ` · ${phone}` : ""}`;
  return (
    <div className="bf-agent-cats" data-testid="bf-agent-catalogs">
      <div className="st-section-title"><BookOpen size={12} /> Cataloage de trimis saloanelor</div>
      <ul>
        {list.map((k) => (
          <li key={k.id} data-testid={`bf-agent-catalog-${k.id}`}>
            <div><b>{k.title}</b><small>{brand(k.brand)} · PDF{k.size ? ` · ${Math.round(k.size / 1048576)} MB` : ""}</small></div>
            <div className="share-actions">
              <a className="st-btn st-btn--light" href={`https://wa.me/?text=${encodeURIComponent(text(k))}`} target="_blank" rel="noopener noreferrer" data-testid={`bf-agent-catalog-wa-${k.id}`}><WhatsAppGlyph /> Trimite pe WhatsApp</a>
              <button type="button" className="st-btn st-btn--ghost" onClick={() => navigator.clipboard.writeText(link(k)).then(() => toast.success("Link catalog copiat"))} data-testid={`bf-agent-catalog-copy-${k.id}`}><Copy size={14} /> Copiază linkul</button>
              <a className="st-btn st-btn--ghost" href={catalogUrl(k.id)} target="_blank" rel="noopener noreferrer" data-testid={`bf-agent-catalog-open-${k.id}`}><ExternalLink size={14} /> Deschide</a>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
